import React, { Component } from 'react';
import './GroupDirShDashboard.css';
import { Breadcrumb, Select, Button, message, Input, Divider } from 'antd';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import GroupDirShGrid from './GroupDirShGrid';
import AddOrEditGroupDirShModalDialog from './AddOrEditGroupDirShModalDialog';
import DelGroupDirShModalDialog from './DelGroupDirShModalDialog';
import OperationRecordDialog from '../../../common/operationRcd/components/OperationRecordDialog';

class GroupDirShDashboard extends Component {

    componentDidMount() {
        if (!this.props.countryCodeDOArray || this.props.countryCodeDOArray.length === 0) {
            this.props.loadCountryCodes();
        }
        this.props.queryGroupDirSh();
    }

    componentDidUpdate() {
        const {
            queryGroupDirShStatus,
            queryGroupDirShResp,
        } = this.props;
        if (queryGroupDirShStatus === ACTION_STATUS.SUCCESS) {
            this.props.initQueryGroupDirShActionStatus();
        }
        if (queryGroupDirShStatus === ACTION_STATUS.ERROR) {
            let err = 'Query Group DirSh failed';
            if (!!queryGroupDirShResp && !!queryGroupDirShResp.respMessage) {
                err = queryGroupDirShResp.respMessage;
            }
            message.error(err);
            this.props.initQueryGroupDirShActionStatus();
        }
    }

    refreshBtnOnClicked = () => {
        this.props.queryGroupDirSh();
    }

    addOrEditGroupDirShBtnOnClicked = mode => {
        if (mode === 'ADD') {
            this.props.openAddOrEditGroupDirShModal(mode, null);
            return;
        }
        const { selectedGroupDirShArray } = this.props;
        if (!selectedGroupDirShArray || selectedGroupDirShArray.length !== 1) {
            message.warn('Please select one and only one Group DirSh');
            return;
        }
        this.props.openAddOrEditGroupDirShModal(mode, selectedGroupDirShArray[0]);
    }

    delGroupDirShBtnOnClicked = () => {
        const { selectedGroupDirShArray } = this.props;
        if (!selectedGroupDirShArray || selectedGroupDirShArray.length !== 1) {
            message.warn('Please select one and only one Group DirSh');
            return;
        }
        this.props.openDelGroupDirShModal(selectedGroupDirShArray[0]);
    }

    opRcdCustomColumns = ['operator', 'operateTime', 'dataId', 'operateType', 'comments', 'before', 'after'];

    operationRecordBtnOnClicked = () => {
        const { selectedGroupDirShArray } = this.props;
        const queryFields = { module: 'GroupDirSh' };
        if (selectedGroupDirShArray && selectedGroupDirShArray.length > 0) {
            queryFields.dataId = selectedGroupDirShArray.map(item => item.id).join(',');
        }
        this.props.doOperationRecordAction({
            action: 'OPEN_AND_QUERY',
            queryFields,
            customColumns: this.opRcdCustomColumns,
        });
    };

    render() {
        const {
            queryFields,
            queryGroupDirShStatus,
        } = this.props;

        const refreshBtnIsLoading = queryGroupDirShStatus === ACTION_STATUS.LOGINING;

        return (
            <div className='GroupDirShWrapper'>
                <div className='breadcrumbWrapper'>
                    <Breadcrumb>
                        <Breadcrumb.Item>Pinpoint Group</Breadcrumb.Item>
                        <Breadcrumb.Item>Group DirSh</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className='OperationBar'>
                    <Input
                        size='small'
                        style={{ width: 160, marginLeft: 10 }}
                        placeholder='Entity Name Eng'
                        value={queryFields.entityNameEng}
                        onChange={e => this.props.groupDirShQueryChangeInput({ name: 'entityNameEng', value: e.target.value })}
                    />
                    <Input
                        size='small'
                        style={{ width: 160, marginLeft: 10 }}
                        placeholder='Position'
                        value={queryFields.position}
                        onChange={e => this.props.groupDirShQueryChangeInput({ name: 'position', value: e.target.value })}
                    />
                    <Input
                        size='small'
                        style={{ width: 180, marginLeft: 10 }}
                        placeholder='Legal Name'
                        value={queryFields.legalNameEng}
                        onChange={e => this.props.groupDirShQueryChangeInput({ name: 'legalNameEng', value: e.target.value })}
                    />
                    <Select
                        size='small'
                        style={{ width: 120, marginLeft: 10 }}
                        value={queryFields.currentStatus}
                        onChange={value => this.props.groupDirShQueryChangeInput({ name: 'currentStatus', value })}
                    >
                        <Select.Option key='Current'>Current</Select.Option>
                        <Select.Option key='All'>All</Select.Option>
                    </Select>

                    <Button
                        onClick={this.refreshBtnOnClicked}
                        loading={refreshBtnIsLoading}
                        size='small'
                        style={{ marginLeft: 10 }}
                        type='primary'
                        icon='search'
                    />

                    <Divider type='vertical' />

                    <Button
                        onClick={() => this.addOrEditGroupDirShBtnOnClicked('ADD')}
                        size='small'
                        className='positive-button'>
                        Add
                    </Button>
                    <Button
                        onClick={() => this.addOrEditGroupDirShBtnOnClicked('EDIT')}
                        size='small'
                        style={{ marginLeft: 10 }}
                        type='primary'>
                        Edit
                    </Button>
                    <Button
                        onClick={this.delGroupDirShBtnOnClicked}
                        size='small'
                        style={{ marginLeft: 10 }}
                        className='negative-button'>
                        Del
                    </Button>

                    <Divider type='vertical' />

                    <Button
                        onClick={this.operationRecordBtnOnClicked}
                        size='small'
                        type='primary'>
                        Operation Record
                    </Button>
                </div>

                <div className='GroupDirShGrid'><GroupDirShGrid {...this.props} /></div>
                <AddOrEditGroupDirShModalDialog {...this.props} />
                <DelGroupDirShModalDialog {...this.props} />
                <OperationRecordDialog {...this.props} />
            </div>
        );
    }
}

export default GroupDirShDashboard;
